import React from 'react';
import {Trans} from 'react-i18next';
import poweredByStripe from '../../../assets/img/powered-by-stripe.svg';
import ProtectedDataLabel from '../ProtectedDataLabel';
import {Wrapper} from './styled';

type SafeAndSecurePaymentInfoProps = {
  className?: string;
};
function SafeAndSecurePaymentInfo({className}: SafeAndSecurePaymentInfoProps) {
  return (
    <Wrapper className={className}>
      <ProtectedDataLabel
        text={
          <span>
            <Trans i18nKey={'safe_and_secure_payment_with_3d_secure'}>
              <b>Safe and secure</b> payment with 3D Secure
            </Trans>
          </span>
        }
      />
      <img src={poweredByStripe} alt="powered by stripe" width={90} height={20} />
    </Wrapper>
  );
}

export default SafeAndSecurePaymentInfo;
